<template>
     <!--客户管理-->
    <div :class="phoneClass || 'user-list-container'">
        <content-header></content-header>
        <div class="dealer-table">
            <div class="search-bar">
                <div class="search-left">
<!--                    <div class="status-index">
                        <span class="top-title">{{$t("user.serviceProvider")}}</span>
                        <el-select v-model="searchForm.agentId" placeholder="请选择服务商" @change="getUserList">
                            <el-option
                                    v-for="item in agentList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>-->

                    <div class="status-index">
                        <span class="top-title" style="width: 100px">{{$t("user.serviceProvider")}}</span>
                        <el-select v-model="searchForm.agentId" clearable style="width:240px;" @change="initPage(),getUserList()">
                            <el-option
                                    v-for="item in agentAllList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="status-index">
                        <span class="top-title" style="width: 110px">{{$t("user.applicationStatus")}}</span>
                        <el-select v-model="userStatus" clearable style="width:160px;" :placeholder="$t('message.select')" @change="initPage(),getUserList()">
                            <el-option
                                    v-for="item in applyStatus"
                                    :key="item.index"
                                    :label="$t('selectData.user.status.status'+item.value)"
                                    :value="item.value">

                            </el-option>
                        </el-select>
                    </div>
                    <el-input
                            class="status-index"
                            :placeholder="$t('user.selectAddress')"
                            clearable
                            style="width:240px"
                            v-model="searchForm.address"
                            @change="initPage(),getUserList()">
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <div class="search-right">
                    <el-input
                            :placeholder="$t('user.selectUser')"
                            style="width:260px"
                            v-model="searchForm.username"
                            @change="initPage(),getUserList()">
                        <i slot="prefix" class="el-input__icon el-icon-search" ></i>
                    </el-input>
                </div>
            </div>
            <div class="table-outer">
                <el-table :data="userList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column min-width="180px" prop="company" :label="$t('user.customerName')"></el-table-column>
                    <el-table-column min-width="120px" prop="phone" :label="$t('user.phone')"></el-table-column>
                    <el-table-column min-width="180px" prop="email" :label="$t('user.email')" ></el-table-column>
                    <el-table-column min-width="400px" prop="address" :label="$t('user.address')" >
                        <template slot-scope="scope">
                            {{scope.row.country + scope.row.province + scope.row.city + scope.row.county +
                            scope.row.address}}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100px" prop="contact_name" :label="$t('user.dealer')">
                        <template slot-scope="scope">
                            {{scope.row.agent_detail ? scope.row.agent_detail.name: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px" prop="create_time" :label="$t('user.correlationTime')">
                        <template slot-scope="scope">
                            {{scope.row.create_time | timeFormat(3)}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column min-width="80px" :label="$t('user.disabled')" fixed="right">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.flagEnable"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeApi(scope.row, scope)">
                            </el-switch>
                        </template>
                    </el-table-column> -->
                    <el-table-column min-width="120px" :label="$t('user.apiSwitch')" fixed="right">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.flagApi"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeApi(scope.row, scope)">
                            </el-switch>
                            <a class="font-color-button" @click="showApiOpen(scope.row)" v-if="scope.row.flagApi === true">{{$t('user.view')}}</a>
                        </template>
                    </el-table-column>
                  <el-table-column min-width="120px" :label="$t('user.opcSwitch')" fixed="right">
                    <template slot-scope="scope">
                      <el-switch
                          v-model="scope.row.flagOpc"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          @change="changeOpc(scope.row, scope)">
                      </el-switch>
                        <a class="font-color-button" @click="showOpcOpen(scope.row)" v-if="scope.row.flagOpc === true">{{$t('user.view')}}</a>
                    </template>
                  </el-table-column>
                    <el-table-column min-width="180px" :label="$t('setting.microsoft_authenticator')" fixed="right" v-if="user.role === 1">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.flagMfa"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeMfa(scope.row)">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column min-width="120px" :label="$t('setting.loginKey')" fixed="right" v-if="user.role === 1">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.flagAutoLoginKey"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeAutoLoginKey(scope.row)">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('user.operation')" align="center" fixed="right" width="360" class-name="customer-operation-cell">
                        <div slot-scope="scope" class='my-table-button'>
                            <!--查看客户所属分组-->
                            <el-button v-if="user.role === 1" type="success" @click="showCustomerMember(scope.row)">
                                {{$t('user.view_group')}}
                            </el-button>
                            <el-button type="success"
                                    @click="clickDisabled(scope.row)">
                                {{ scope.row.is_enable === 0 ? $t('user.disabled'): $t('user.enabled')}}
                            </el-button>
                            <el-dropdown trigger="click" class="more-dropdown">
                                <el-button type="success">
                                    {{$t('user.more')}}<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <!--服务商更换及新申请处理统一收纳到更多菜单-->
                                    <el-dropdown-item>
                                        <div @click="changeAgent(scope.row)">{{scope.row.apply_status === 0 ? $t('user.replace') : $t('user.new_apply')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div @click="clickEditEmail(scope.row)">{{$t('user.edit_email')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <div @click="clickEdit(scope.row)">{{$t('user.eidt')}}</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item v-if="user.role === 1 || user.role === 100">
                                        <div @click="clearDevice(scope.row)">{{$t('user.clear_device')}}</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination" style="text-align:right;padding:20px;">
                <el-pagination
                        @current-change="pageChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total"
                        background>
                </el-pagination>
            </div>
            <el-dialog width="calc(100% - 48px)" top="8vh" custom-class="customer-member-dialog" :title="$t('user.customerName') + '：' + customerMemberTitle" :visible.sync="showCustomerMemberDialog">
                <customer-group-list v-loading="customerMemberLoading" :account-list="customerMemberList"></customer-group-list>
                <div slot="footer" class="customer-member-footer">
                    <span class="customer-member-total">{{$t('authority.group_name')}}：{{customerMemberTotal}}</span>
                    <el-pagination @current-change="customerMemberPageChange" :current-page="customerMemberPage" :page-size="pageSize" :total="customerMemberTotal" layout="prev, pager, next" :disabled="customerMemberLoading" background></el-pagination>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="更改服务商" :visible.sync="showChangeAgent" class="detail-change">
                <div class="dialog">
                    <div class="dialog-top">
                        <!--原服务商：-->
                        <span style="">{{$t('user.origin')}} :</span>
                        <div class="content">{{this.agentForm.agent_detail ? this.agentForm.agent_detail.name: '-'}}
                        </div>
                    </div>
                    <!--<div class="dialog-top">-->
                        <!--<span>申请更改:</span>-->
                        <!--<div class="content">{{this.agentForm.apply_agent_detail ? this.agentForm.apply_agent_detail.name: '-'}}-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="dialog" style="border-top: 1px solid #ccc;">
                    <div class="dialog-content">
                        <!--更换服务商为：-->
                        <span style="font-size: 14px;color: #363D42;">{{$t('user.replace_are')}}:</span>
                    </div>
                    <div class="dialog-select">
                        <el-select v-model="agentId" :placeholder="$t('message.select')">
                            <el-option
                                    v-for="item in agentAllList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="cancel" @click="cancelChange">取消</el-button>
                    <el-button type="primary" class="confirm" @click="confirmChangeAgent">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" :title="$t('user.edit_email')" :visible.sync="showEditEmail" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ editRow.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('user.email')}}:</div>
                            <div class="form-value">
                                <el-input
                                    :placeholder="$t('user.email')"
                                    style="width:260px"
                                    v-model="newEmail">
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="cancel" @click="showEditEmail = false">取消</el-button>
                    <el-button type="primary" class="confirm" @click="confirmChangeEmail">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="修改密码" :visible.sync="showEdit" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ editRow.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('user.new_password')}}:</div>
                            <div class="form-value">
                                <el-input
                                    :placeholder="$t('retrieve.new_password')"
                                    style="width:260px"
                                    v-model="newPassword">
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="cancel" @click="showEdit = false">取消</el-button>
                    <el-button type="primary" class="confirm" @click="confirmChangePassword">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="查看api" :visible.sync="showApi" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ appData.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.appId')}}</div>
                            <div class="form-value">
                                {{appData.appId}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.appSecret')}}</div>
                            <div class="form-value">
                                {{appData.appSecret}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.alarmUrl')}}</div>
                            <div class="form-value">
                                {{appData.alarmUrl}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.dataReportUrl')}}</div>
                            <div class="form-value">
                                {{appData.dataReportUrl}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.deviceAddUrl')}}</div>
                            <div class="form-value">
                                {{appData.deviceAddUrl}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="confirm" @click="showApi = false">关闭</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="查看opc" :visible.sync="showOpc" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ opcData.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('user.opcParam')}}:</div>
                            <div class="form-value">
                                {{ opcData.opc_param }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="confirm" @click="showOpc = false">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>


<script>
    import Core from "core/core";
    import contentHeader from '../../components/content-header'
    import customerGroupList from '../../components/customer-group-list'
    import region from "core/region"
    import {refresh} from "core/winSize"

    export default {
        data() {
            return {
	            phoneClass: '',
                agentAllList: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                searchForm: {
                    agentId: '',
                    username: '',
                    address: ''
                },
                applyStatus: [
	                {
		                value: '',
		                label: '全部'
	                }, {
		                value: '1',
		                label: '新申请'
	                }
                ],
                user: {
                },
	            userStatus: '',
                userList: [],
                showCustomerMemberDialog: false,
                customerMemberTitle: '',
                customerMemberId: 0,
                customerMemberList: [],
                customerMemberPage: 1,
                customerMemberTotal: 0,
                customerMemberLoading: false,
                customerMemberRequestId: 0,
                showChangeAgent: false,
                showEdit: false,
                showEditEmail: false,
                popoverVisible: false,
                editRow: {},
                newPassword: '',
                newEmail: '',
                agentForm: {
                    selectAgentId: '',
                    userId: ''
                },
                agentId: '',
                agentValue: '',

                appData: {
                    id: '',
                    appId: '',
                    appSecret: '',
                    alarmUrl: '',
                    dataReportUrl: '',
                    deviceAddUrl: '',
                    company: '',
                },
                opcData: {
                    opc_param: '',
                    company: '',
                },

                showApi: false,
                showOpc: false,
            };
        },
        components: {
            customerGroupList,
            contentHeader
        },
	    created() {
            this.initUserData()
		    refresh(this,'phoneClass-user-list-container');
		    window.onresize = function(){
			    setTimeout(function(){
				    refresh(this,'phoneClass-user-list-container');
			    },10)
		    };
	    },
        mounted() {
            this.getAgentListAll();
            this.getUserList()
        },
        computed: {},
        methods: {
            /** 点击查看分组，展示该客户下的组长和组员。 */
            showCustomerMember(row) {
                this.customerMemberId = row.id;
                this.customerMemberTitle = row.company || row.email || '-';
                this.customerMemberPage = 1;
                this.customerMemberTotal = 0;
                this.showCustomerMemberDialog = true;
                this.getCustomerMemberList();
            },
            /** 切换分组列表页码。 */
            customerMemberPageChange(page) {
                this.customerMemberPage = page;
                this.getCustomerMemberList();
            },
            /** 请求序号避免快速切换客户或页码时旧数据覆盖新数据。 */
            getCustomerMemberList() {
                const requestId = ++this.customerMemberRequestId;
                this.customerMemberList = [];
                this.customerMemberLoading = true;
                Core.Api.User.customerMemberList(this.customerMemberId, this.customerMemberPage).then(res => {
                    if (requestId !== this.customerMemberRequestId) return;
                    this.customerMemberList = res.list || [];
                    this.customerMemberTotal = res.count || 0;
                    this.customerMemberLoading = false;
                }).catch(error => {
                    if (requestId !== this.customerMemberRequestId) return;
                    this.customerMemberLoading = false;
                    console.error('查询客户组长和组员失败', error);
                    this.$message.error('查询组长和组员失败，请稍后重试');
                });
            },
            initUserData(){
                this.user = Core.Data.getUser()
                // console.log (this.user,'user')
            },
            getUserList() {
                // 按客户名称、客户邮箱及下属组长和组员邮箱搜索。
                Core.Api.User.listAdmin(this.currentPage, this.searchForm.agentId, this.searchForm.username, this.userStatus, this.searchForm.address).then(res => {
                    this.userList = res.list;
                    this.userList.forEach(item=>{
                        item.flagApi = !!item.is_open_api_enable;
                        item.flagOpc = !!item.is_opc_enable;
                        item.flagMfa = !!item.is_mfa_enable;
                        item.flagAutoLoginKey = !!item.is_auto_login_key_enable;
                    })
                    this.total = res.count
                })
            },
            getAgentListAll() {
                Core.Api.Agent.listAll().then(res => {
                    // console.log(res, "###");
                    this.agentAllList = [
                    {
                        name: '-',
                        id: 0
                    },
                    ...res.agent_list]
                })
            },
            pageChange(val) {
                this.currentPage = val;
                this.getUserList();
            },
            changeAgent(val,x) {
                this.showChangeAgent = true
                this.agentForm = val
                console.log(val,"val" )
                this.agentId = val.agent_id
            },
            confirmChangeAgent() {
	            this.$confirm('本次操作将更换该用户的运营商, 是否继续?', '提示', {
		            cancelButtonText: '取消',
		            confirmButtonText: '确定',
		            type: 'warning'
	            })
	            .then(() => {
		            console.log(this.agentForm);
		            return Core.Api.User.switchUserAgent(this.agentId, this.agentForm.id)
	            })
	            .then(() => {
		            this.$message.success('修改成功');
		            this.getUserList()
		            this.cancelChange()
	            })

            },
            /**确认修改密码 */
            confirmChangePassword() {
                Core.Api.User.updatePassword(this.editRow.id, this.newPassword).then(res =>{
                    this.$message.success('修改成功');
                    this.showEdit = false;
                }).catch(err => {
                    this.$message.warning('修改失败');
                    this.showEdit = false;
                })
            },
            /**确认修改邮箱 */
            confirmChangeEmail() {
                const email = this.newEmail.trim();
                if (!email) {
                    this.$message.error('请输入邮箱');
                    return;
                }
                if (!Core.Const.EMAIL_REG.test(email)) {
                    this.$message.error('邮箱格式不正确');
                    return;
                }
                Core.Api.User.updateEmail(this.editRow.id, email).then(() => {
                    this.$message.success('修改成功');
                    this.showEditEmail = false;
                    this.getUserList();
                })
            },
            /**切换API状态 */
            changeApi(row) {
                // console.log(row.flagApi ? 0 : row.app.id)
                // return;
                let flag = row.is_open_api_enable ? 0 : 1;
                Core.Api.User.openApi(row.id, flag, row.id).then(res =>{
                    let tips = row.company;
                    tips += row.flagApi ? ' 已开启API' : ' 已关闭API';
                    this.$message.success(tips);
                    this.getUserList();
                })
                // Core.Api.User.generateLoginKey(row.id).then(res => {
                //     console.log(res, "###");
                // })
            },
            /**切换API状态 */
            changeOpc(row) {
                let flag = row.is_opc_enable ? 0 : 1;
                Core.Api.User.opc(row.id, flag).then(res =>{
                    let tips = row.company;
                    tips += row.flagOpc ? ' 已开启OPC' : ' 已关闭OPC';
                    this.$message.success(tips);
                    this.getUserList();
                })
                // Core.Api.User.generateLoginKey(row.id).then(res => {
                //     console.log(res, "###");
                // })
            },
            /**切换 Microsoft Authenticator MFA 状态 */
            changeMfa(row) {
                let flag = row.is_mfa_enable ? 0 : 1;
                Core.Api.User.mfaEnable(row.id, flag).then(() => {
                    let tips = row.company;
                    tips += row.flagMfa ? ' 已开启 Microsoft Authenticator' : ' 已关闭 Microsoft Authenticator';
                    this.$message.success(tips);
                    this.getUserList();
                }).catch(() => {
                    row.flagMfa = !row.flagMfa;
                })
            },
            /**切换免登地址状态 */
            changeAutoLoginKey(row) {
                let flag = row.is_auto_login_key_enable ? 0 : 1;
                Core.Api.User.autoLoginKeyEnable(row.id, flag).then(() => {
                    let tips = row.company;
                    tips += row.flagAutoLoginKey ? ' 已开启免登地址' : ' 已关闭免登地址';
                    this.$message.success(tips);
                    this.getUserList();
                }).catch(() => {
                    row.flagAutoLoginKey = !row.flagAutoLoginKey;
                })
            },
            /**点击编辑 */
            clickEdit(row) {
                this.newPassword = "";
                this.editRow = row;
                this.showEdit = true;
            },
            /**点击修改邮箱 */
            clickEditEmail(row) {
                this.newEmail = row.email || '';
                this.editRow = row;
                this.showEditEmail = true;
            },
            /**点击删除 */
            clearDevice(row) {
                const ths = this;
                console.log('clearDevice>>', row);

                ths.$confirm('确定清空设备？?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    Core.Api.Device.deleteDeviceByUserId(row.id).then(res =>{
                        ths.$message({
                            type: 'success',
                            message: '清除成功!'
                        });
                    })

                });
            },

            clickDisabled(row) {
                Core.Api.User.enable(row.id).then(res =>{
                    let tips = row.company;
                    tips += row.is_enable ? ' 已启用' : ' 已禁用';
                    this.$message.success(tips);
                    this.getUserList();
                })
            },
            /**点击删除 */
            clickDelete(row) {
                const ths = this;
                console.log('clickDelete>>', row);

                ths.$confirm('确定删除该客户？?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    ths.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
            },

            initPage(){
                this.currentPage = 1
                console.log("现在是第"+this.currentPage+"页");
            },
            cancelChange() {
                this.showChangeAgent = false
            },
            showApiOpen(item) {
                Core.Api.App.detailByUserId(item.id).then(res =>{
                    this.appData = res.detail
                    this.appData.company = item.company;
                })

                this.showApi = true;
            },
            showOpcOpen(item) {
                this.opcData.company = item.company;
                Core.Api.User.opcDetail(item.id).then(res =>{
                    this.opcData.opc_param = res.opc_mq_routing_key
                })

                this.showOpc = true;
            }
        },


    };
</script>

<style scoped lang="scss">
    @import '../../assets/style/mixin.scss';

    .user-list-container {
        background-color: #E5EBEF;
        height: 100%;
        .dealer-table {
            margin: 30px 40px;
            background-color: #FFFFFF;
            .search-bar {
                @include flex-sb;
                padding: 20px;
                .status-index {
                    margin-right: 12px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .search-left {

            }
            .search-right {

            }
            .table-outer {
                padding: 0 20px;
            }
            .more-dropdown {
                margin-left: 10px;
                vertical-align: middle;
            }
            .detail-change {
                .dialog {
                    margin: 20px;

                    .dialog-top {
                        margin: 10px;
                        .content {
                            margin-left: 10px;
                            display: inline;
                        }
                    }
                    .dialog-content {
                        margin: 10px;
                    }
                    .dialog-select {
                        margin: 5px 10px 10px 10px;
                        display: inline-block;
                    }
                }
                .dialog-form {
                    width: 100%;
                    .form-item {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 15px;
                    }
                    // justify-content: space-between;
                    .form-label {
                        width: 120px;
                    }
                    .form-value {
                        width: calc(100% - 100px);
                    }
                }
                .dialog-bottom {
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: center;
                    .confirm {
                        margin: 10px 10px;
                    }
                    .cancel {
                        width: 62px;
                        height: 28px;
                        margin-right: 10px;
                    }
                }
            }
        }
        .font-color-button{
            color: #0A3D95;
            cursor:pointer;
            font-size: 8px;
            padding-left: 5px;
        }
    }
</style>

<style lang="scss">
    // 操作栏始终单行排列，覆盖单元格悬停时允许换行的通用样式。
    .el-table .customer-operation-cell {
        .cell, .cell:hover {
            white-space: nowrap;
        }
        .my-table-button {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            gap: 10px;
            >.el-button, >.el-dropdown {
                flex-shrink: 0;
                margin-left: 0;
            }
            .el-button { white-space: nowrap; }
        }
    }
    // 仅调整客户分组弹窗，正文独立滚动，页码始终留在底部。
    .el-dialog.customer-member-dialog {
        max-width: 1360px;
        overflow: hidden;
        border-radius: 10px;
        .el-dialog__header {
            padding: 18px 24px;
            background: #FFFFFF;
        }
        .el-dialog__title { font-weight: 600; color: #303D50; }
        .el-dialog__headerbtn {
            top: 20px;
            right: 24px;
            .el-dialog__close { color: #8592A3; }
        }
        .el-dialog__body { padding: 0; }
        .el-dialog__footer {
            padding: 14px 24px;
            border-top: 1px solid #E7ECF2;
            background: #FFFFFF;
        }
        .customer-member-footer {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
        }
        .customer-member-total { font-size: 13px; color: #8592A3; }
        @media (max-width: 768px) {
            .el-dialog__header, .el-dialog__footer { padding: 14px 12px; }
        }
    }
    .user-list-container {
        .el-button {
            background: #f5f8fa;
            border: 1px #ecf0f4 solid;
            color: #8e9db0
        }
        .el-button:active ,.el-button:hover{
            border: 1px #bad4ff solid;
            color: #2b6cda

        }

        .table-outer {
            .cell {
                white-space:nowrap;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
            }
            .cell:hover {
                /*background: #e2e2e2;*/
                white-space: normal;
                overflow: visible; //超出的文本隐藏
                position: relative;
                z-index: 10000;
                text-overflow:clip;
                /*background: #f6f7fb;*/
            }

        }
    }
    .phoneClass-user-list-container {
        .dealer-table {
            .search-bar{
                padding-left: 10px;
                .search-left {
                margin-bottom: 15px;
                    display: flex;
                    flex-wrap: wrap;
                    .status-index {
                        margin-top: 15px;
                        .top-title {
                            width: 110px !important;
                        }
                        .el-select {
                            width: 60% !important;
                        }
                    }

                    div:nth-child(2) {
                        .el-select{
                        }
                    }
                }
                .search-right {
                    margin-bottom: 15px;
                }
            }
        }
        .el-button {
            background: #f5f8fa;
            border: 1px #ecf0f4 solid;
            color: #8e9db0;
        }
        .is-center {
            .cell {
                .my-table-button {
                    .el-button {
                        span {

                            font-size: 10px !important;
                        }
                    }
                }
                /*width: 100px;*/
            }
        }
        /*页码适配移动端*/
        .pagination {
            padding: 20px 0 !important;
            text-align: center !important;
            .el-pagination {
                padding: 0;
                button {
                    width: 20px;
                    min-width: 0;
                    height: 30px;
                }
                .el-pager {
                    .number {
                        margin: 0 3px !important;
                        padding: 0 !important;
                        min-width: 0px;
                        width: 20px !important;
                        height: 30px !important;
                    }
                    .el-icon-more {

                        margin: 0 3px !important;
                        padding: 0 !important;
                        min-width: 0px;
                        width: 20px !important;
                        height: 30px !important;
                    }
                }
            }
        }
    }
</style>
